export const version = '07.05.1'

export const BACKEND_URL_PREFIX = process.env.REACT_APP_URL
export const BACKEND_DOMAIN = process.env.REACT_APP_BACKEND_DOMAIN

export const REQUEST_STATUSES = {
  SUBMITTED: 'submitted',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  COMPLETED: 'completed',
  WITHDRAWN: 'withdrawn',
}

export const REQUESTS = [
  {
    title: 'Название мероприятия',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    result: 'публикуется после завершения мероприятия',
    submittedAt: '22.09.2026',
    status: REQUEST_STATUSES.SUBMITTED,
  },
  {
    title: 'Название мероприятия',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    result: 'публикуется после завершения мероприятия',
    submittedAt: '22.09.2026',
    status: REQUEST_STATUSES.APPROVED,
  },
  {
    title: 'Название мероприятия',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    result: 'публикуется после завершения мероприятия',
    submittedAt: '22.09.2026',
    status: REQUEST_STATUSES.REJECTED,
  },
  {
    title: 'Название мероприятия',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    result: '2 место',
    submittedAt: '22.09.2026',
    status: REQUEST_STATUSES.COMPLETED,
  },
]

export const ORGANIZER_EVENT_STATUSES = {
  ACCEPTING: 'accepting',
  IN_PROGRESS: 'in_progress',
}

const COMMISSION = [
  'Николаев Николай Николаевич',
  'Дмитриев Дмитрий Дмитриевич',
  'Васильев Василий Васильевич',
]

export const ORGANIZER_ACTIVE_EVENTS = [
  {
    title: 'Всероссийская олимпиада по программированию',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    commission: COMMISSION,
    status: ORGANIZER_EVENT_STATUSES.ACCEPTING,
  },
  {
    title: 'Всероссийская олимпиада по программированию',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    commission: COMMISSION,
    status: ORGANIZER_EVENT_STATUSES.ACCEPTING,
  },
  {
    title: 'Всероссийская олимпиада по программированию',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    commission: COMMISSION,
    status: ORGANIZER_EVENT_STATUSES.IN_PROGRESS,
  },
  {
    title: 'Всероссийская олимпиада по программированию',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    commission: COMMISSION,
    status: ORGANIZER_EVENT_STATUSES.ACCEPTING,
  },
]

const REQUEST_PARTICIPANTS = [
  { name: 'Николаев Николай Николаевич', code: '3400' },
  { name: 'Дмитриев Дмитрий Дмитриевич', code: '2210' },
  { name: 'Васильев Василий Васильевич', code: '98' },
]

const REQUEST_SUPERVISORS = [
  { name: 'Николаев Николай Николаевич', position: 'Должность, звание', phone: '+7 954 112 34 67' },
  { name: 'Николаев Николай Николаевич', position: 'Должность, звание', phone: '+7 954 112 34 67' },
]

export const ORGANIZER_REQUEST_STATUSES = {
  NEW: 'new',
  APPROVED: 'approved',
  REJECTED: 'rejected',
}

export const ORGANIZER_EVENT_REQUESTS = [
  {
    number: 2,
    projectName: 'Название работы (проекта)',
    institution: 'Название училища',
    participants: REQUEST_PARTICIPANTS,
    supervisors: REQUEST_SUPERVISORS,
    equipment: 'Проектор, стол, микрофон',
    submittedAt: '22.09.2026',
    status: ORGANIZER_REQUEST_STATUSES.NEW,
  },
  {
    number: 1,
    projectName: 'Название работы (проекта)',
    institution: 'Название училища',
    participants: REQUEST_PARTICIPANTS,
    supervisors: REQUEST_SUPERVISORS,
    equipment: 'Проектор, стол, микрофон',
    submittedAt: '22.09.2026',
    status: ORGANIZER_REQUEST_STATUSES.NEW,
  },
  {
    number: 3,
    projectName: 'Название работы (проекта)',
    institution: 'Название училища',
    participants: REQUEST_PARTICIPANTS,
    supervisors: REQUEST_SUPERVISORS,
    equipment: 'Проектор, стол, микрофон',
    submittedAt: '20.09.2026',
    status: ORGANIZER_REQUEST_STATUSES.APPROVED,
  },
  {
    number: 4,
    projectName: 'Название работы (проекта)',
    institution: 'Название училища',
    participants: REQUEST_PARTICIPANTS,
    supervisors: REQUEST_SUPERVISORS,
    equipment: 'Проектор, стол, микрофон',
    submittedAt: '18.09.2026',
    status: ORGANIZER_REQUEST_STATUSES.REJECTED,
  },
]

export const ORGANIZER_CURRENT_EVENT_TITLE = 'Всероссийская олимпиада по программированию'

export const ORGANIZER_CLOSED_EVENTS = [
  {
    title: 'Всероссийская олимпиада по программированию',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    commission: COMMISSION,
    hasResults: true,
  },
  {
    title: 'Всероссийская олимпиада по программированию',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    commission: COMMISSION,
    hasResults: false,
  },
]

export const EVENTS = [
  {
    title: 'Всероссийская олимпиада по программированию',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    description: ''
  },
  {
    title: 'Всероссийская олимпиада по программированию',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    description: ''
  },
  {
    title: 'Всероссийская олимпиада по программированию',
    location: 'Место',
    dates: '02.10.2026 — 12.10.2026',
    description: 'Приглашаем обучающихся 9–11 классов довузовских образовательных учреждений принять участие в ежегодной открытой олимпиаде по программированию. Олимпиада проводится с целью выявления и развития у обучающихся творческих способностей и интереса к научной деятельности в области информационных технологий. Победители и призёры награждаются дипломами и ценными призами. Все участники получают сертификаты.'
  },
]